import GAController from './GAController';
import GAEntityItem from './GAEntityItem';
import ScrollView from '../helpers/ScrollView';

export default class GA {
    private static item: GAEntityItem[];

    static init(url: string[]) {
        GAController.init(url);
    }

    static indexPageScrollHandler() {
        ScrollView.indexPageScrollHandler();
        const observerConfig = {
            attributeFilter: ['data-ga-viewed'],
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true,
        };

        const observer = new MutationObserver((mutationsList, observer) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'attributes') {
                    if (mutation.attributeName === 'data-ga-viewed') {
                        const parentSection = (
                            mutation.target as Element
                        ).closest('.content_wrapper_block');
                        const itemContainer = (
                            mutation.target as Element
                        ).closest('.item');
                        const art = (mutation.target as Element).querySelector(
                            '.article_block'
                        );
                        const artValue = (art as HTMLElement).dataset.value;
                        const titleDiv = (
                            mutation.target as Element
                        ).querySelector('.item-title');
                        const titleValue = (titleDiv as HTMLElement).dataset
                            .gaTitle;

                        const index =
                            Number(
                                (itemContainer as HTMLElement).dataset.gaIndex
                            ) + 1;
                        const price = (
                            mutation.target as Element
                        ).querySelector('.price');
                        const priceDiscount = (
                            mutation.target as Element
                        ).querySelector('.price.discount');
                        let discount = null;

                        if (priceDiscount !== null) {
                            discount =
                                Number(
                                    (priceDiscount as HTMLElement).dataset.value
                                ) -
                                Number((price as HTMLElement).dataset.value);
                            console.log(
                                Number(
                                    (priceDiscount as HTMLElement).dataset.value
                                )
                            );
                            console.log(
                                Number((price as HTMLElement).dataset.value)
                            );
                        }

                        console.log(discount);
                        console.log(mutation.target);
                        const items = [
                            {
                                currency: 'RUB',
                                index,
                                item_id: artValue,
                                item_name: titleValue,
                                item_brand: '5lb',
                                //affiliation?: string;
                                //coupon?: string;
                                //creative_name?: string;
                                //creative_slot?: string;
                                //discount?: number;

                                //item_category?: string;
                                //item_category2?: string;
                                //item_category3?: string;
                                //item_category4?: string;
                                //item_category5?: string;
                                //item_list_id: string;
                                //item_list_name: string;
                                //item_variant?: string;
                                //location_id: string;
                                //price: number;
                                //promotion_id?: string;
                                //promotion_name?: string;
                                quantity: 1,
                            },
                        ];

                        const gaParams = {
                            ecommerce: {
                                items,
                            },
                            event: 'view_item_list',
                        };

                        console.log(gaParams);
                    }
                }
            }
        });

        observer.observe(document.querySelector('body'), observerConfig);
    }
}
